import { IGroupsHasProducts } from '@llws/platform-shared-types/types/db/auth';
import { ActionContext } from 'vuex';
import { baseRequest } from '@/shared/request-configs/base-request';
import config from '@/config';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath = '/perms-api/groups__has_products';

const base = new StoreBaseImplementationV2<Partial<IGroupsHasProducts>>({
  adminGatewayResourcePath,
});

export default {
  namespaced: true,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
